import { SCRIPT_IMG, ScriptImage } from "@/components/ScriptImage";

export default function AboutUsPanel() {
  return (
    <div
      data-testid="panel-block-about"
      className="max-w-[680px] mx-auto px-2 md:px-0 pb-16"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      <div className="text-center pt-2">
        <ScriptImage src={SCRIPT_IMG.about} alt="About Us" />
      </div>
      <div className="mt-10 flex justify-center">
        <img
          src={`${process.env.REACT_APP_BACKEND_URL}/api/photos/about-us-florence.jpg`}
          alt="Scott and Isabelle in Florence"
          data-testid="about-us-florence-photo"
          className="w-[70%] max-w-[420px] h-auto"
          loading="lazy"
        />
      </div>
      <div className="mt-10 space-y-6 text-[15px] md:text-base leading-[1.8] text-[#2C1A1D]/85">
        <p>
          Scott and Isabelle met under the Italian sun in the summer of 2024,
          amongst the courtyard of the wedding of two beloved friends.
          Following some (slightly spontaneous) travel in the company of a
          small group of friends through Europe, they stayed in touch upon
          returning back to their homes, in Melbourne and the Gold Coast.
        </p>
        <p>
          However, life would have other plans, and across two different
          states their unique love story began to take shape. Before long,
          Scott had moved to Melbourne to begin a new chapter of life with
          Isabelle, and their whirlwind journey reached its fruition when at
          last, Scott asked Isabelle to marry him &mdash; a question met with
          a resounding yes.
        </p>
        <p>
          Now, Scott and Isabelle invite you to share the beginning of their
          next chapter, as they continue their special story together.
        </p>
        <div className="pt-6 flex justify-center">
          <ScriptImage src={SCRIPT_IMG.couple} alt="Scott and Isabelle" height="26px" />
        </div>
      </div>
    </div>
  );
}
